import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    component: () => import('../views/login.vue')
  },
  {
    path: '/',
    redirect: 'home',
    component: () => import('../views/main.vue'),
    children: [
      {
        path: 'home',
        component: () => import('../views/home/home.vue')
      },
      {
        path: 'bookResource',
        component: () => import('../views/bookResource/bookResource.vue')
      },
      {
        path: 'search',
        component: () => import('../views/search/search.vue'),
      },
      {
        path: 'upload',
        component: () => import('../views/upload/upload.vue')
      },
      {
        path: 'examine',
        component: () => import('../views/examine/examine.vue')
      },
      {
        path: 'schoolResource',
        component: () => import('../views/schoolResource/schoolResource.vue')
      }
      ,
      {
        path: 'mine',
        component: () => import('../views/mine/mine.vue')
      },
      {
        path: 'followResource',
        component: () => import('../views/followResource/followResource.vue')
      },
      {
        path: 'account',
        component: () => import('../views/account/account.vue')
      },
      {
        path: 'authorIndex',
        component: () => import('../views/authorIndex/authorIndex.vue')
      },
      {
        path: 'schoolMine',
        component: () => import('../views/schoolMine/schoolMine.vue')
      },
      {
        path: 'register',
        component: () => import('../views/register/register.vue')
      },
      {
        path: 'mineResource',
        component: () => import('../views/mineResource/mineResource.vue')
      },
      {
        path: 'searchDetail',
        component: () => import('../views/searchDetail/searchDetail.vue')
      },
      {
        path: 'filePreview',
        component: () => import('../views/filePreview/filePreview.vue')
      },
      {
        path: 'addSchool',
        component: () => import('../views/addSchool/addSchool.vue')
      },
    ]
  },
]

const router = new VueRouter({
  routes
})

export default router
